import React,{useState,useEffect} from 'react';
import { Image} from 'react-bootstrap';
import { useSpring, a } from '@react-spring/web'

function ShuffleCard(props) {


  const [show, showCard] = useState(props.shuffle == "shuffle");

  const { opacity } = useSpring({
    to: {opacity: (show) ? 1 : 0},
    config: { mass: 5, tension: 500, friction: 80, duration:1000 }
  });

  useEffect(() => {
    if (props.shuffle == "shuffle" && show){
      showCard(false);
      props.onShuffle();
    }
  },[show]);
  
  
  function handleClick(){
    //Make card appear
    var s = show;
    showCard(true);
    setTimeout(function(){
     props.onClick();
    },500)
  }

  var zIndex = -1;
  if (show){
    zIndex = 99;
  }
  return (

     <div>
        <div className="cardno" style={{opacity:1}}>{props.cardno}</div>
        <a.div className="c back" style={{position:'absolute', display: 'inline-block', width:`${props.width}`,minWidth:`${props.minWidth}`, zIndex:zIndex, opacity: opacity.to(o => o) }}>
            <Image  src="cards/cover.jpg" thumbnail style={{overflow:'hidden', width:`${props.width}`,minWidth:`${props.minWidth}`, height: `${props.height}`, maxHeight: `${props.maxHeight}`}} />
        </a.div>
        
        <div className="shadowbutton" onClick={handleClick} style={{position:'absolute', display: 'inline-block', width:`${props.width}`, height: `${props.height}`, opacity: opacity.to(o => 1 - o)}}>
    
        </div>
        
      </div>
  )
};

export default ShuffleCard;